import i18n from "../../utils/i18n";

const ShiftMembersFilters = ({
  sortOptions,
  sortValue,
  sortDirection,
  filterValue,
  onSortValueChange, 
  onSortDirectionChange,
  onFilterChange
}) => {
  const sortOptionsItems = sortOptions.map((option) => (
    <option key={option} value={option}>
      {i18n.t('schedule.shifts.members.sort_options.' + option)}
    </option>
  ));

  return (
    <div className="row">
      <form className="inline-form">
        <div className="col-xs-4">
          <div className="form-group">
            <select
              value={sortValue}
              onChange={onSortValueChange}
              className="form-control"
            >
              {sortOptionsItems}
            </select>
          </div>
        </div>
        <div className="col-xs-1" style={{ padding: '0' }}>
          <button
            className="btn btn-white"
            onClick={onSortDirectionChange}
            style={{ marginTop: '0' }}
          >
            <i className={`fa fa-sort-amount-${sortDirection}`}></i>
          </button>
        </div>
        <div className="col-xs-offset-3 col-xs-4">
          <div className="form-group">
            <input
              type="text"
              value={filterValue}
              onChange={onFilterChange}
              className="form-control"
              placeholder={i18n.t('schedule.shifts.members.search_by_name')}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ShiftMembersFilters;
